import { render, staticRenderFns } from "./03-Reflections.vue?vue&type=template&id=740130c8&scoped=true&"
import script from "./03-Reflections.vue?vue&type=script&lang=js&"
export * from "./03-Reflections.vue?vue&type=script&lang=js&"
import style0 from "./03-Reflections.vue?vue&type=style&index=0&id=740130c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740130c8",
  null
  
)

export default component.exports